import React, { useEffect, useRef, useState } from 'react';
import Layout from 'components/layout';
import { Col, Container, Row } from '@bootstrap-styled/v4';
import styled, { keyframes } from 'styled-components';
import { anton, montserrat } from 'shared-components/theme/fonts';
import { baseURL } from 'shared-components/theme/helpers';
import Media from 'shared-components/theme/medias';
import colors from 'shared-components/theme/colors';
import ScrollAnimation from 'react-animate-on-scroll';

const AppWrapper = styled.div`
    background-color: #0f0e0e;
    color: white;

    #home,
    #about,
    #nominees,
    #past-winners,
    #enroll {
        scroll-margin-top: 5.164vw;

        ${Media('mobile')} {
            scroll-margin-top: 12vw;
        }
    }
`;

const Navigation = styled.nav`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 1rem;
    z-index: 50;
    padding: 20px 140px;
    transition: 0.3s ease;
    ${Media('xlscreens')} {
        padding: 20px 7.2vw;
    }
    ${Media('tablet')} {
        padding: 20px 30px;
    }
    ${Media('mobile')} {
        padding: 20px 0;
    }

    .awards_logo {
        transition: 0.3s ease;
        ${Media('tablet')} {
            max-width: 80%;
        }
        ${Media('mobile')} {
            max-width: 70%;
            margin-left: 20px;
        }
    }
`;
const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const NavList = styled.ul`
    display: flex;
    justify-content: flex-end;
    gap: 3rem;
    list-style: none;
    display: flex;

    ${Media('tabletlandscape')} {
        display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
        flex-direction: column;
        gap: 1.5rem;
        flex-direction: column;
        width: 100%;
        overflow: hidden;
        max-height: ${({ isOpen }) => (isOpen ? '500px' : '0')};
        opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
        transition: max-height 0.5s ease, opacity 0.3s ease;
        animation: ${({ isOpen }) => (isOpen ? slideDown : 'none')} 0.3s ease;
        border-bottom: 1px solid ${colors.white[100]};
        padding-bottom: 20px;
        padding-top: 20px;

        position: absolute;
        top: 170px;
        left: 0;
        z-index: 2;
        width: 100%;
        background: ${colors.black[100]};
    }
`;

const NavLink = styled.a`
    font-family: ${montserrat};
    font-weight: 600;
    font-size: 20px;
    transition: color 0.2s;
    color: ${colors.white[100]};
    position: relative;
    text-decoration: none;
    ${Media('large')} {
        font-size: 0.9vw;
    }
    ${Media('tablet')} {
        font-size: 16px;
    }
    &:hover {
        color: ${colors.pink[100]};
    }

    &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -2px;
        width: 0;
        height: 2px;
        background-color: ${colors.pink[100]};
        transition: width 0.3s ease-in-out, left 0.3s ease-in-out;
    }

    &:hover::after {
        width: 100%;
        left: 0;
    }
`;
const Hamburger = styled.div`
    display: none;
    flex-direction: column;
    cursor: pointer;
    align-items: flex-end;

    @media (max-width: 991px) {
        display: flex;
        max-width: max-content;
        margin-left: auto;
        margin-right: 20px;
    }

    span {
        height: 3px;
        width: 25px;
        background-color: white;
        margin-bottom: 4px;
        transition: all 0.3s ease;

        &:nth-child(1) {
            transform: ${({ isOpen }) =>
                isOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none'};
        }

        &:nth-child(2) {
            opacity: ${({ isOpen }) => (isOpen ? '0' : '1')};
            width: 15px;
            background: #123cf4;
        }

        &:nth-child(3) {
            transform: ${({ isOpen }) =>
                isOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none'};
        }
    }
`;

// Hero section
const Section = styled.div`
    padding: 20px 140px;
    ${Media('xlscreens')} {
        padding: 20px 7.2vw;
    }
    ${Media('tablet')} {
        padding: 20px 30px;
    }
    ${Media('mobile')} {
        padding: 20px 0;
    }
`;
const HeroSection = styled.div`
    position: relative;

    .row_2 {
        margin-left: 100px;
        margin-top: -34px;
        align-items: center;

        @media (max-width: 1540px) {
            margin-top: -80px;
        }
        @media (max-width: 1366px) {
            margin-top: -50px;
            margin-left: 0;
            flex-direction: column-reverse;

            .col-lg-3,
            .col-lg-9 {
                max-width: 100%;
                text-align: center;
            }
        }
        @media (max-width: 1280px) {
            margin-top: 0;

            .col-lg-3,
            .col-lg-9 {
                max-width: 100%;
                text-align: center;
            }
        }
    }

    .good_text {
        padding-left: 90px;

        @media (max-width: 1550px) {
            padding-left: 50px;
        }

        @media (max-width: 1366px) {
            padding-left: 0px;
        }
    }
`;

const TitleRow = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    @media (max-width: 1366px) {
        justify-content: center;
    }
    ${Media('tabletlandscape')} {
        padding-left: 16px;
    }
    ${Media('mobile')} {
        padding-left: 0;
    }
    span {
        color: #ebe9e2;
        font-size: 200px;
        font-family: ${anton};
        line-height: 1;

        ${Media('large')} {
            font-size: 13vw;
        }
        @media (max-width: 1540px) {
            font-size: 180px;
        }
        @media (max-width: 1399px) {
            font-size: 160px;
        }
        @media (max-width: 1280px) {
            font-size: 150px;
        }
        @media (max-width: 1180px) {
            font-size: 134px;
        }
        ${Media('tabletlandscape')} {
            font-size: 110px;
        }
        ${Media('mobile')} {
            font-size: 90px;
        }
        @media (max-width: 575px) {
            font-size: 70px;
        }
        ${Media('mobileportrait')} {
            font-size: 60px;
        }
        @media (max-width: 420px) {
            font-size: 50px;
        }
    }

    .bold_ico {
        margin: 24px -90px 0 -50px;
        position: relative;
        z-index: 5;
        animation: grow 5s linear infinite;
        @keyframes grow {
            0% {
                transform: scale(1);
            }
            100% {
                transform: scale(0.8);
            }
        }
        @media (max-width: 1280px) {
            margin: 24px -40px 0 -40px;
            width: 11%;
        }
        ${Media('tabletlandscape')} {
            width: 100px;
        }
        ${Media('mobile')} {
            margin: 24px -34px 0 -34px;
        }
        @media (max-width: 575px) {
            margin: 24px -20px 0 -20px;
            width: 70px;
        }
        ${Media('mobileportrait')} {
            margin: 4px -14px 0 -14px;
            width: 50px;
        }
    }
`;

const Description = styled.div`
    margin-top: 2rem;
    max-width: 28rem;

    @media (max-width: 1366px) {
        margin: 2rem auto;
        max-width: 50%;
    }
    @media (max-width: 991px) {
        max-width: 70%;
    }
    ${Media('mobile')} {
        max-width: 90%;
    }
    @media (max-width: 575px) {
        margin: 1rem auto;
    }
`;

const DescriptionText = styled.p`
    font-size: 18px;
    margin-bottom: 2rem;
    margin-top: 0;
    font-family: ${montserrat};
    font-weight: 500;
    letter-spacing: 0px;
    color: ${colors.white[100]};

    ${Media('large')} {
        font-size: 1.071vw;
    }

    @media (max-width: 1280px) {
        font-size: 16px;
    }
`;

const Button = styled.a`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: transparent;
    border: 2px solid white;
    padding: 0.75rem 1.5rem;
    color: white;
    transition: all 0.3s;
    border-radius: 8px;
    position: relative;
    width: 100%;
    max-width: 95%;
    @media (max-width: 1366px) {
        max-width: 50%;
        margin: auto;
    }
    @media (max-width: 1180px) {
        max-width: 60%;
    }
    @media (max-width: 991px) {
        max-width: 50%;
    }
    ${Media('mobile')} {
        max-width: 60%;
    }
    ${Media('mobileportrait')} {
        max-width: 70%;
    }
    span {
        position: relative;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.5rem;
        font-family: ${montserrat};
        font-weight: 600;
        transition: 0.3s ease;
        font-size: 18px;
        width: 100%;
        ${Media('large')} {
            font-size: 1.071vw;
        }

        @media (max-width: 1280px) {
            font-size: 16px;
        }
        ${Media('mobile')} {
            font-size: 12px;
        }
    }
    &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0px;
        height: 0px;
        background: rgb(255, 255, 255);
        border-radius: 8px;
        transition: 0.4s;
        z-index: 8;
        opacity: 0;
    }
    &:hover {
        &:before {
            width: 96%;
            height: 86%;
            opacity: 1;
        }

        span {
            color: rgb(250, 0, 96);
        }
    }

    svg {
        transition: transform 0.3s;
    }
`;

const CircleDecoration = styled.div`
    width: 220px;
    height: 220px;
    position: absolute;
    z-index: 1;
    right: 140px;
    top: 196px;

    @media (max-width: 1366px) {
        width: 160px;
        height: 160px;
        right: 200px;
    }
    @media (max-width: 1280px) {
        top: 120px;
    }
    @media (max-width: 1180px) {
        right: 150px;
    }
    @media (max-width: 1080px) {
        width: 120px !important;
        height: 120px !important;
        right: 170px;
    }
    ${Media('tabletlandscape')} {
        right: 120px;
    }
    @media (max-width: 1080px) {
        width: 80px !important;
        height: 80px !important;
        right: 100px;
        top: 122px;
    }
    @media (max-width: 575px) {
        top: 90%;
        width: 40px !important;
        height: 40px !important;
        right: 18%;
    }
`;

const RotatingCircle = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    animation: spin 10s linear infinite;
    position: relative;
    transform-origin: center;
    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    img {
        width: 100%;
    }
`;
// Hero section

// CX Leaders
const CxLeaders = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 50px 0;
    ${Media('mobile')} {
        flex-wrap: wrap;
        .animated {
            max-width: 50%;
        }
    }
`;
const Profile = styled.div`
    position: relative;
    overflow: hidden;
    max-width: 100%;
    width: 100%;

    p {
        position: absolute;
        top: 6px;
        left: 30px;
        font-family: ${montserrat};
        font-weight: 500;
        font-size: 20px;
        z-index: 1;
        margin: 0;
        ${Media('laptops')} {
            font-size: 14px;
            font-weight: 600;
            left: 10px;
            top: 4px;
        }
        ${Media('tabletlandscape')} {
            top: unset;
            bottom: 0;
            left: 0;
            background: ${colors.pink[50]};
            color: ${colors.white[100]};
            width: 100%;
            padding: 6px;
        }
        ${Media('mobile')} {
            font-size: 12px;
        }
    }
    .profile_bg {
        position: absolute;
        width: 100%;
        height: 100%;
    }
    .profile_img {
        width: 100%;
        position: relative;
        transition: 0.3s ease;

        ${Media('mobile')} {
            height: 55.411vw;
            object-fit: cover;
        }
    }

    &:hover {
        .profile_img {
            transform: scale(1.05);
        }
    }
`;

// About
const AboutCx = styled.div`
    background: #ebe9e2;
    border-radius: 16px;
    padding: 100px;
    ${Media('mobile')} {
        padding: 30px;
    }
    h3 {
        font-size: 40px;
        font-family: ${montserrat};
        font-weight: 600;

        ${Media('large')} {
            font-size: 2.38vw;
        }
        ${Media('mobile')} {
            font-size: 28px;
        }
    }
`;
const HighlightsWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;

    margin-top: 40px;

    ${Media('large')} {
        margin-top: 2.38vw;
    }
    ${Media('mobile')} {
        flex-wrap: wrap;
        justify-content: center;
    }
`;
const Highlight = styled.div`
    img {
        width: 100%;
    }

    h5 {
        transition: 0.3s ease;
        text-transform: uppercase;
    }

    &:hover {
        h5 {
            background: ${colors.pink[100]};
            color: ${colors.white[100]};
        }
    }
`;
const Title = styled.h5`
    font-family: ${anton};
    font-size: 25px;
    color: #0d0d0d;
    background: #fff;
    border-radius: 10px;
    text-decoration: underline;
    text-align: center;
    padding: 10px;
    font-weight: 400;
    margin-top: 10px;

    ${Media('mobile')} {
        font-size: 18px;
    }
`;
const Info = styled.div`
    margin: 50px 0;
    padding: 0 60px;

    ${Media('large')} {
        padding: 0 2.974vw;
    }
    ${Media('tabletlandscape')} {
        padding: 0;
    }
    ${Media('mobile')} {
        margin: 30px 0;
    }

    h5 {
        font-size: 32px;
        font-family: ${anton};
        margin: 0 0 20px;
        color: ${colors.black[100]};
        font-weight: 400;
        text-transform: uppercase;

        ${Media('mobile')} {
            font-size: 22px;
        }
    }

    p {
        font-size: 20px;
        font-family: ${montserrat};
        font-weight: 600;

        ${Media('mobile')} {
            font-size: 16px;
        }
    }
`;

// Marquee content

// Left to Right Animation
const slideLTR = keyframes`
  from { transform: translateX(-50%); }
  to { transform: translateX(0%); }
`;

// Right to Left Animation
const slideRTL = keyframes`
  from { transform: translateX(0%); }
  to { transform: translateX(-50%); }
`;

const AwardsWrap = styled.div`
    margin-top: -80px;
    margin-bottom: -40px;
    transform: rotate(-1deg);
`;

const Strip = styled.div`
    width: 100%;
    overflow: hidden;
    padding: 20px 0;
    white-space: nowrap;
    position: relative;
    background: ${(props) => props.bgColor || '#000'};
    transform: ${(props) => props.transform};
    margin: ${(props) => props.margin};
    transform-origin: ${(props) => props.transformOrigin};
    position: ${(props) => props.position};
    z-index: ${(props) => props.zIndex};

    ${Media('mobile')} {
        padding: 10px 0;
    }
`;

const MarqueeWrapper = styled.div`
    overflow: hidden;
    display: flex;
    width: 100%;
`;

const MarqueeContent = styled.div`
    display: inline-block;
    animation: scroll 15s linear infinite;
    font-size: 22px;
    font-family: ${anton};
    font-weight: 400;
    color: ${(props) => props.color || '#fff'};
    animation: ${(props) => (props.direction === 'ltr' ? slideLTR : slideRTL)}
        10s linear infinite;

    @keyframes scroll {
        from {
            transform: translateX(0%);
        }
        to {
            transform: translateX(-50%);
        }
    }

    ${Media('mobile')} {
        font-size: 16px;
    }
`;

// Nominees styles
const Nominees = styled.div`
    background: #fe481f;
    padding: 70px 80px 120px;
    h2 {
        text-align: center;
        font-family: ${montserrat};
        font-weight: 600;
        font-size: 40px;
        color: #000;
        ${Media('large')} {
            font-size: 2.38vw;
        }
        ${Media('mobile')} {
            font-size: 28px;
        }
    }
    ${Media('tabletlandscape')} {
        padding: 40px 20px;
    }

    .nominees_row {
        justify-content: center;
    }
`;
// Past Winners
const PastWinners = styled.div``;
const BackgroundText = styled.div`
    position: relative;
    margin-top: -80px;
    ${Media('tabletlandscape')} {
        margin-top: -40px;
    }

    img {
        width: 100%;
        ${Media('tabletlandscape')} {
            width: 120vw;
        }
    }
`;

const WinnerCard = styled.div`
    background: #ebe9e2;
    border: 2px solid ${colors.black[100]};
    border-radius: 22px;
    padding: 20px 20px 30px;
    margin: 15px 0;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    min-height: 510px;
    transition: 0.3s ease;
    @media (max-width: 1366px) {
        min-height: 450px;
        padding: 15px 15px 20px;
    }
    &:hover {
        border-color: ${colors.white[100]};
    }
`;

const Image = styled.img`
    width: 100%;
    margin-bottom: 10px;
    transition: 0.3s ease;
`;

const Name = styled.h3`
    font-size: 22px;
    color: #000000;
    font-family: ${anton};
    font-weight: 400;
    margin: 0;
    transition: 0.3s ease;
    text-transform: capitalize;

    ${Media('large')} {
        font-size: 1.2vw;
    }
    ${Media('mobile')} {
        font-size: 18px;
    }
`;

const Role = styled.p`
    font-size: 17px;
    color: #0f0e0e;
    font-family: ${montserrat};
    font-weight: 500;
    transition: 0.3s ease;
    max-width: 85%;
    margin: 0;
    ${Media('large')} {
        font-size: 0.9vw;
    }
    ${Media('mobile')} {
        max-width: 100%;
        font-size: 14px;
    }
`;
const WinnerCardFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    marign-top: 10px;

    a {
        transition: 0.3s ease;
        &:hover {
            transform: scale(1.1);
        }
    }

    ${Media('mobile')} {
        .linkedin_ico {
            width: 20px;
        }
    }
`;
const CompanyLogo = styled.img`
    transition: 0.3s ease;
`;

// Mising
const NominationContainer = styled.div`
    width: 100%;
    max-width: 100%;
    padding: 0 4vw 4vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
`;

const NominationCard = styled.div`
    border-radius: 1vw;
    overflow: hidden;
    box-shadow: 0 0.5vw 1vw rgba(0, 0, 0, 0.2);
    width: 100%;
`;

const NominationHeader = styled.div`
    background-color: #f5f5f0;
    padding: 3vw 6vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2vw;
    border-radius: 17px;
    margin-bottom: 2px;
    ${Media('mobile')} {
        border-radius: 8px;
    }
    @media (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 1.5vw;
    }
`;

const NominationTitle = styled.h2`
    margin: 0;
    font-size: 2.5vw;
    color: #000;
    max-width: 60%;
    line-height: 1.2;
    font-family: ${montserrat};
    font-weight: 600;
    @media (max-width: 768px) {
        font-size: 22px;
        max-width: 100%;
    }
`;

const NominationActions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-family: ${montserrat};
    font-weight: 500;
    @media (max-width: 600px) {
        align-items: flex-start;
        width: 100%;
    }
`;

const NominateText = styled.p`
    margin: 0;
    font-size: 1.6vw;
    margin-bottom: 0.5vw;
    font-family: ${montserrat};
    font-weight: 600;
    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const NominateLink = styled.a`
    color: #0066cc;
    text-decoration: none;
    font-size: 1.6vw;
    font-family: ${montserrat};
    font-weight: 600;
    text-decoration: underline;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const NominationFooter = styled.div`
    background-color: #fe481f;
    color: ${colors.black[100]};
    padding: 2.4vw 4vw;
    text-align: center;
    font-size: 1.6vw;
    font-family: ${montserrat};
    font-weight: 600;
    border-radius: 14px;
    @media (max-width: 768px) {
        font-size: 18px;
        padding: 3vw 4vw;
    }
    ${Media('mobile')} {
        border-radius: 8px;
        padding: 3vw 8vw 3vw 6vw;
        text-align: left;
    }
`;

// data
const profiles = [
    {
        id: 1,
        profileBg: `${baseURL}assets/images/cx-awards/2025/leader-bg-1.jpg`,
        profileImg: `${baseURL}assets/images/cx-awards/2025/leader-1.png`,
        name: 'Past Winner: Darrell Anderson',
    },
    {
        id: 2,
        profileBg: `${baseURL}assets/images/cx-awards/2025/leader-bg-2.jpg`,
        profileImg: `${baseURL}assets/images/cx-awards/2025/leader-2.png`,
        name: 'Past Winner: Adam seede',
    },
    {
        id: 3,
        profileBg: `${baseURL}assets/images/cx-awards/2025/leader-bg-3.jpg`,
        profileImg: `${baseURL}assets/images/cx-awards/2025/leader-3.png`,
        name: 'Past Winner: Stacie Parrish',
    },
    {
        id: 4,
        profileBg: ``,
        profileImg: `${baseURL}assets/images/cx-awards/2025/leader-4.jpg`,
        name: 'Winner:',
        href: '#nominees',
    },
];

const highlights = [
    {
        id: 1,
        img: `${baseURL}assets/images/cx-awards/2025/illustration-1.png`,
        title: 'Innovation',
    },
    {
        id: 2,
        img: `${baseURL}assets/images/cx-awards/2025/illustration-2.png`,
        title: 'Collaboration',
    },
    {
        id: 3,
        img: `${baseURL}assets/images/cx-awards/2025/illustration-3.png`,
        title: 'Performance',
    },
];

// Winners
const winners = [
    {
        name: 'Darrell Anderson',
        img: `${baseURL}assets/images/cx-awards/2025/past-winner-1.png`,
        designation: 'Enterprise Global Strategy Senior Lead',
        brand: `${baseURL}assets/images/cx-awards/2025/past-winner-logo-1.svg`,
    },
    {
        name: 'Roger brewer',
        img: `${baseURL}assets/images/cx-awards/2025/past-winner-2.png`,
        designation: 'Director Service Tools  and Technology',
        brand: `${baseURL}assets/images/cx-awards/2025/past-winner-logo-2.svg`,
    },
    {
        name: 'Nicole geosits',
        img: `${baseURL}assets/images/cx-awards/2025/past-winner-3.png`,
        designation: 'Director of Customer Support, Acuity Scheduling',
        brand: `${baseURL}assets/images/cx-awards/2025/past-winner-logo-3.svg`,
    },
    {
        name: 'Jason Entwistle',
        img: `${baseURL}assets/images/cx-awards/2025/past-winner-4.png`,
        designation: 'Senior Director, Vendor Management and Care Operations',
        brand: `${baseURL}assets/images/cx-awards/2025/past-winner-logo-4.svg`,
    },
    {
        name: 'David bartsch',
        img: `${baseURL}assets/images/cx-awards/2025/past-winner-5.png`,
        designation: 'Business Operations  & Planning Manager',
        brand: `${baseURL}assets/images/cx-awards/2025/past-winner-logo-5.svg`,
    },
    {
        name: 'Allen ng',
        img: `${baseURL}assets/images/cx-awards/2025/past-winner-6.png`,
        designation: 'Global Contact Center & Customer Support Director',
        brand: `${baseURL}assets/images/cx-awards/2025/past-winner-logo-6.svg`,
    },
    {
        name: 'Ashleigh hill',
        img: `${baseURL}assets/images/cx-awards/2025/past-winner-7.png`,
        designation: 'National Sales Manager',
        brand: `${baseURL}assets/images/cx-awards/2025/past-winner-logo-7.svg`,
    },
    {
        name: 'Stacie Parrish',
        img: `${baseURL}assets/images/cx-awards/2025/past-winner-8.png`,
        designation: 'VP of Member Support',
        brand: `${baseURL}assets/images/cx-awards/2025/past-winner-logo-8.svg`,
    },
    {
        name: 'Matthew dolkart',
        img: `${baseURL}assets/images/cx-awards/2025/past-winner-9.png`,
        designation: 'Sr. Vendor Manager,  Guest Services ',
        brand: `${baseURL}assets/images/cx-awards/2025/past-winner-logo-9.svg`,
    },
    {
        name: 'Adam seede',
        img: `${baseURL}assets/images/cx-awards/2025/past-winner-10.png`,
        designation: 'Director, Guest Services / Customer Care',
        brand: `${baseURL}assets/images/cx-awards/2025/past-winner-logo-9.svg`,
    },
    {
        name: 'Emily rama',
        img: `${baseURL}assets/images/cx-awards/2025/past-winner-12.png`,
        designation: 'Director of Member Support Process + Content',
        brand: `${baseURL}assets/images/cx-awards/2025/past-winner-logo-12.svg`,
    },
    {
        name: 'Howard sharpley',
        img: `${baseURL}assets/images/cx-awards/2025/past-winner-11.png`,
        designation: 'VP of Global Customer  Support and Services',
        brand: `${baseURL}assets/images/cx-awards/2025/past-winner-logo-11.svg`,
    },
];

const currentWinners = [
    {
        name: 'Vanessa Hardy-Bowen',
        img: `${baseURL}assets/images/cx-awards/2025/winner-1.webp`,
        designation: 'Director, Guest Care & Contact Centers',
        brand: `${baseURL}assets/images/cx-awards/2025/winner-logo-1.svg`,
        linkedIn: 'https://www.linkedin.com/in/vanessa-hardy-bowen-407290b',
    },
    {
        name: 'Ryan Moore',
        img: `${baseURL}assets/images/cx-awards/2025/winner-2.webp`,
        designation: 'VP, Customer Support & BPO Strategy',
        brand: `${baseURL}assets/images/cx-awards/2025/winner-logo-2.svg`,
        linkedIn: 'https://www.linkedin.com/in/ryan-moore-44532a94',
    },
    {
        name: 'Natalie Beckerman',
        img: `${baseURL}assets/images/cx-awards/2025/winner-3.webp`,
        designation: 'Global Head, Customer Support Operations',
        brand: `${baseURL}assets/images/cx-awards/2025/winner-logo-3.svg`,
        linkedIn: 'https://www.linkedin.com/in/nataliedbeckerman1',
    },
    {
        name: 'Michael Jones',
        img: `${baseURL}assets/images/cx-awards/2025/winner-4.webp`,
        designation: 'Senior Director - Customer Care',
        brand: `${baseURL}assets/images/cx-awards/2025/winner-logo-4.svg`,
        linkedIn: '',
    },
    {
        name: 'Lisa Wysocky',
        img: `${baseURL}assets/images/cx-awards/2025/winner-5.webp`,
        designation: 'Sr. Director of Channel and  Partner Management',
        brand: `${baseURL}assets/images/cx-awards/2025/winner-logo-5.svg`,
        linkedIn: 'https://www.linkedin.com/in/lisawysocky',
    },
    // {
    //     name: 'Jason Swift',
    //     img: `${baseURL}assets/images/cx-awards/2025/winner-6.webp`,
    //     designation: 'SVP, Operations Strategy',
    //     brand: `${baseURL}assets/images/cx-awards/2025/winner-logo-6.png`,
    //     linkedIn: 'https://www.linkedin.com/in/jason-swift-4275883',
    // },
    {
        name: 'Jeremy Victor',
        img: `${baseURL}assets/images/cx-awards/2025/winner-7.webp`,
        designation: 'Chief Customer Officer',
        brand: `${baseURL}assets/images/cx-awards/2025/winner-logo-7.svg`,
        linkedIn: 'https://www.linkedin.com/in/jeremyvictor',
    },
    {
        name: 'Lionel Holguin',
        img: `${baseURL}assets/images/cx-awards/2025/winner-8.webp`,
        designation: 'Head of Customer Service and Collections',
        brand: `${baseURL}assets/images/cx-awards/2025/winner-logo-8.svg`,
        linkedIn: 'https://www.linkedin.com/in/lionel-h-6331a8146',
    },
];

const CxLeaderShipAwards2025 = () => {
    const sliderRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [progress, setProgress] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // slick settings

    return (
        <Layout darkTheme>
            <AppWrapper>
                {/* Navigation */}
                <Navigation>
                    <a href="#home">
                        <img
                            src={`${baseURL}assets/images/cx-awards/2025/logo.svg?time=${new Date().getDate()}`}
                            className="awards_logo"
                        />
                    </a>
                    <>
                        <Hamburger onClick={toggleMenu}>
                            {isOpen ? (
                                <div
                                    style={{
                                        fontSize: '30px',
                                        fontFamily: '"Montserrat", serif',
                                    }}>
                                    x
                                </div>
                            ) : (
                                <>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </>
                            )}
                        </Hamburger>
                        <NavList isOpen={isOpen}>
                            <li>
                                <NavLink onClick={toggleMenu} href="#home">
                                    HOME
                                </NavLink>
                            </li>
                            <li>
                                <NavLink onClick={toggleMenu} href="#about">
                                    ABOUT
                                </NavLink>
                            </li>
                            <li>
                                <NavLink onClick={toggleMenu} href="#nominees">
                                    2025 WINNERS
                                </NavLink>
                            </li>
                            <li>
                                <NavLink onClick={toggleMenu} href="#enroll">
                                    ENROLL
                                </NavLink>
                            </li>
                        </NavList>
                    </>
                </Navigation>

                {/* Hero Section */}

                <Section id="home">
                    <HeroSection>
                        <ScrollAnimation
                            animateIn="fadeInLeft"
                            animateOnce={true}
                            duration={1.5}>
                            <TitleRow>
                                <span>WE LIKE </span>
                                <img
                                    src={`${baseURL}assets/images/cx-awards/2025/bold-ico.svg`}
                                    className="bold_ico"
                                />
                                <span>THE WAY</span>
                                <CircleDecoration>
                                    <RotatingCircle>
                                        <img
                                            src={`${baseURL}assets/images/cx-awards/2025/circle-text.png?img=ibex`}
                                        />
                                    </RotatingCircle>
                                </CircleDecoration>
                            </TitleRow>

                            <Row className="row_2">
                                <Col lg="3">
                                    <Description>
                                        <DescriptionText>
                                            The CX Leadership Awards honor the
                                            top CX innovators, leaders, and
                                            contributors to the CX space.
                                        </DescriptionText>
                                        <Button href="#nominees">
                                            <span>
                                                SEE THE WINNERS
                                                <img
                                                    src={`${baseURL}assets/images/cx-awards/2025/star.svg`}
                                                />
                                            </span>
                                        </Button>
                                    </Description>
                                </Col>
                                <Col lg="9" className="good_text">
                                    <TitleRow>
                                        <span>YOU CX</span>
                                    </TitleRow>
                                </Col>
                            </Row>
                        </ScrollAnimation>
                    </HeroSection>
                </Section>

                {/* Cx Leaders  */}
                <CxLeaders>
                    {profiles.map((profile, index) => (
                        <ScrollAnimation
                            animateIn="fadeInLeft"
                            animateOnce={true}
                            delay={(index + 1) * 250}
                            key={profile.id}
                            className="profile_wrapper">
                            <Profile>
                                <p>{profile.name}</p>
                                <img
                                    src={profile.profileBg}
                                    className="profile_bg"
                                />
                                {profile.href ? (
                                    <a href={profile.href}>
                                        <img
                                            src={profile.profileImg}
                                            className="profile_img"
                                        />
                                    </a>
                                ) : (
                                    <img
                                        src={profile.profileImg}
                                        className="profile_img"
                                    />
                                )}
                            </Profile>
                        </ScrollAnimation>
                    ))}
                </CxLeaders>

                {/* About  */}
                <Section id="about">
                    <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                        <AboutCx>
                            <Row>
                                <Col lg="6">
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        animateOnce={true}
                                        delay={100}>
                                        <h3>
                                            The CX Leadership Awards honor the
                                            top CX innovators, leaders, and
                                            contributors to the CX space.
                                        </h3>
                                    </ScrollAnimation>
                                    <HighlightsWrap>
                                        {highlights.map((highlight, index) => (
                                            <ScrollAnimation
                                                animateIn="fadeInUp"
                                                animateOnce={true}
                                                delay={(index + 1) * 200}
                                                key={highlight.id}>
                                                <Highlight>
                                                    <img src={highlight.img} />
                                                    <Title>
                                                        {highlight.title}
                                                    </Title>
                                                </Highlight>
                                            </ScrollAnimation>
                                        ))}
                                    </HighlightsWrap>
                                </Col>
                                <Col lg="6">
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        animateOnce={true}
                                        delay={300}>
                                        <Info>
                                            <h5>The Winners</h5>
                                            <p>
                                                Award winners demonstrate a
                                                commitment to the customer
                                                experience that goes beyond the
                                                transactional, but to a
                                                fundamental understanding of the
                                                customer journey, resulting in
                                                higher customer satisfaction,
                                                deeper customer l oyalty, and a
                                                satisfying bounce to the bottom
                                                line.
                                            </p>
                                        </Info>
                                    </ScrollAnimation>
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        animateOnce={true}
                                        delay={400}>
                                        <Info>
                                            <h5>Who We Are</h5>
                                            <p>
                                                We’re an advanced CX outsourcer
                                                working with leading high-tech,
                                                fintech, and hyper-growth brands
                                                to deliver high-touch, secure,
                                                on-demand customer experiences
                                                delivered by a global talent
                                                pool of 31,000+ CX experts from
                                                31 omnichannel contact centers
                                                of excellence.
                                            </p>
                                        </Info>
                                    </ScrollAnimation>
                                </Col>
                            </Row>
                        </AboutCx>
                    </ScrollAnimation>
                </Section>

                {/* awards  */}
                <AwardsWrap>
                    <Strip
                        bgColor={'#000000'}
                        transform={'rotate(4deg)'}
                        transformOrigin={'center left'}
                        position={'relative'}
                        zIndex={1}>
                        <MarqueeWrapper>
                            <MarqueeContent color="#FFB5B5" direction="rtl">
                                THE WINNERS • CXL AWARDS • 2025 •THE WINNERS •
                                CXL AWARDS • 2025 •THE WINNERS • CXL AWARDS •
                                2025 •THE WINNERS • CXL AWARDS • 2025 •THE
                                WINNERS • CXL AWARDS • 2025 •THE WINNERS • CXL
                                AWARDS • 2025 •THE WINNERS • CXL AWARDS • 2025 •
                            </MarqueeContent>
                        </MarqueeWrapper>
                    </Strip>
                    <Strip
                        bgColor={'#123CF3'}
                        transform={'rotate(-1.6deg)'}
                        transformOrigin={'center left'}
                        margin={'15px 0'}>
                        <MarqueeWrapper>
                            <MarqueeContent color="#FFD800" direction="ltr">
                                THE WINNERS • CXL AWARDS • 2025 •THE WINNERS •
                                CXL AWARDS • 2025 •THE WINNERS • CXL AWARDS •
                                2025 •THE WINNERS • CXL AWARDS • 2025 •THE
                                WINNERS • CXL AWARDS • 2025 •THE WINNERS • CXL
                                AWARDS • 2025 •THE WINNERS • CXL AWARDS • 2025 •
                            </MarqueeContent>
                        </MarqueeWrapper>
                    </Strip>
                </AwardsWrap>

                {/* Nominees */}
                <Nominees id="nominees">
                    <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                        <h2>The 2025 Winners</h2>
                    </ScrollAnimation>
                    <Row className="nominees_row">
                        {currentWinners.map((winner, i) => (
                            <Col lg="3" key={i}>
                                <WinnerCard>
                                    <Name>{winner.name}</Name>
                                    <Image
                                        src={winner.img}
                                        alt={winner.name}
                                        className="winner_img"
                                    />
                                    <Role>{winner.designation}</Role>
                                    <WinnerCardFooter>
                                        <CompanyLogo
                                            src={winner.brand}
                                            alt={'winners'}
                                            className="company_logo"
                                        />
                                        {winner.linkedIn !== '' ? (
                                            <a
                                                href={winner.linkedIn}
                                                target=" _blank ">
                                                <img
                                                    className="linkedin_ico"
                                                    src={`${baseURL}assets/images/cx-awards/2025/linkedin-ico.svg`}
                                                />
                                            </a>
                                        ) : (
                                            ''
                                        )}
                                    </WinnerCardFooter>
                                </WinnerCard>
                            </Col>
                        ))}
                    </Row>
                </Nominees>

                {/* Past Winners  */}
                <PastWinners id="past-winners">
                    <ScrollAnimation
                        animateIn="fadeInLeft"
                        animateOnce={true}
                        delay={100}>
                        <BackgroundText>
                            <img
                                src={`${baseURL}assets/images/cx-awards/2025/next-winners.png?img=ibex`}
                                alt="past-winners"
                            />
                        </BackgroundText>
                    </ScrollAnimation>
                </PastWinners>

                {/* Missing */}
                <Section id="enroll">
                    <NominationContainer>
                        <NominationCard>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOnce={true}
                                delay={100}>
                                <NominationHeader>
                                    <NominationTitle>
                                        Want to nominate someone for next year’s
                                        awards?
                                    </NominationTitle>
                                    <NominationActions>
                                        <NominateText>
                                            Nominate them now!
                                        </NominateText>
                                        <NominateLink href="mailto:Marketing@ibee.co">
                                            Email Marketing@ibex.co.
                                        </NominateLink>
                                    </NominationActions>
                                </NominationHeader>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOnce={true}
                                delay={200}>
                                <NominationFooter>
                                    See you in 2026!
                                </NominationFooter>
                            </ScrollAnimation>
                        </NominationCard>
                    </NominationContainer>
                </Section>
            </AppWrapper>
        </Layout>
    );
};

export default CxLeaderShipAwards2025;
